import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-login-powered-by',
  templateUrl: './login-powered-by.component.html',
  styleUrls: ['./login-powered-by.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoginPoweredByComponent {
  @Input() logoUrl = '';
  @Input() linkUrl = 'https://aerostudies.com/';
}
